import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalTitleFn = /* @__PURE__ */ createRecipe('modalTitle', {}, [])

const modalTitleVariantMap = {}

const modalTitleVariantKeys = Object.keys(modalTitleVariantMap)

export const modalTitle = /* @__PURE__ */ Object.assign(memo(modalTitleFn.recipeFn), {
  __recipe__: true,
  __name__: 'modalTitle',
  __getCompoundVariantCss__: modalTitleFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: modalTitleVariantKeys,
  variantMap: modalTitleVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalTitleVariantKeys)
  },
  getVariantProps: modalTitleFn.getVariantProps,
})